import React, { useContext } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography'; 
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { IconButton } from "@mui/material";
import { AppContext } from "../../App";

export default function CrewMember(props){

  const {setChangesMade} = useContext(AppContext)

  async function removeMember(e){
    e.preventDefault()
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/removeMember/${user}/${props.id}`,{
      method: 'POST'
    })
    setChangesMade(prev => prev+1)
  }

  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          >
          <Typography>{props.name}</Typography>

        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            ID Number: {props.id}
          </Typography>
          <Typography>
            Date of Birth: {props.dob}
          </Typography>
          <Typography>
            Phone: {props.phone}
          </Typography>
          <Typography>
            Email: {props.email}
          </Typography>
          <Typography>
            Role: {props.role}
          </Typography>
          <IconButton aria-label="delete" onClick={(e)=> removeMember(e)}>
            <DeleteOutlineOutlinedIcon />
          </IconButton>
          
        </AccordionDetails>
      </Accordion>
    </div>
  )
}